require('./CollapseList.scss');

const b = require('app/www/libs/b')('collapse-list');

const React = require('react');
const PropTypes = require('prop-types');

const CollapseItem = require('app/www/components/blocks/CollapseItem/CollapseItem');

class CollapseList extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            openedItemIds: props.openedItemId ? [props.openedItemId] : [],
        };

        this._onToggle = this._onToggle.bind(this);
    }

    render() {
        const {items, mods} = this.props;
        const {openedItemIds} = this.state;

        const collapseItemsProps = {
            mods,
            isOnlyOne: items.length <= 1,
            openItem: this._onToggle,
        };

        const itemsList = items.map(item => {
            const isOpen = openedItemIds.includes(item.id);
            const collapseItemProps = Object.assign({}, collapseItemsProps, {item, isOpen});

            return (
                <li className={b('item')} key={item.id}>
                    <CollapseItem {...collapseItemProps} />
                </li>
            );
        });

        return (
            <ul className={b()}>
                {itemsList}
            </ul>
        );
    }

    _onToggle(id, orderIndex) {
        const {openMultiple, onToggle} = this.props;
        let isOpen = !this.state.openedItemIds.includes(id);

        if (openMultiple) {
            this.setState({
                openedItemIds: isOpen
                    ? this.state.openedItemIds.concat([id])
                    : this.state.openedItemIds.filter(item => item !== id),
            });
        } else {
            this.setState({
                openedItemIds: isOpen ? [id] : null,
            });
        }

        onToggle(id, orderIndex, isOpen);
    }
}

CollapseList.propTypes = {
    items: PropTypes.array.isRequired,
    openedItemId: PropTypes.number,
    openMultiple: PropTypes.bool,
    onToggle: PropTypes.func,
};

module.exports = CollapseList;
